import { AttendanceSheetResponseDto } from '@/api.types';
import { AttendanceSheetDayEnum } from '../../../../enums/attendance-sheet-day.enum';

type Props = { folha: AttendanceSheetResponseDto | undefined; };

export default function AttendanceSheetResumeLittleTable({ folha }: Props) {
  const dias = folha?.dias ?? [];
  return (
    <table className="table table-bordered mb-0 w-100" style={{ tableLayout: 'fixed' }}>
      <colgroup>
        <col style={{ width: '25%' }} />
        <col style={{ width: '25%' }} />
        <col style={{ width: '25%' }} />
        <col style={{ width: '25%' }} />
      </colgroup>
      <tbody>
        <tr>
          <th className="p-1 text-center small" title="Total de dias úteis.">
            Úteis
          </th>
          <th className="p-1 text-center small" title="Dias com presença">
            Presenças
          </th>
          <th className="p-1 text-center small" title="Dias com falta.">
            Faltas
          </th>
          <th className="p-1 text-center small" title="Dias com observações.">
            Obs.
          </th>
        </tr>
        <tr>
          <td className="p-1 text-center">{dias.filter((a) => a.util).length}</td>
          <td className="p-1 text-center">
            {dias.filter((a) => a.status === AttendanceSheetDayEnum.PRESENTE).length}
          </td>
          <td className="p-1 text-center">
            {
              dias.filter(
                (a) =>
                  a.status === AttendanceSheetDayEnum.FALTA_JUSTIFICADA ||
                  a.status === AttendanceSheetDayEnum.FALTA_NAO_JUSTIFICADA,
              ).length
            }
          </td>
          <td className="p-1 text-center">{dias.filter((a) => a.justificativa).length}</td>
        </tr>
      </tbody>
    </table>
  );
}
